import { useQuery } from '@tanstack/react-query'
import { fetchReferralRewards } from '../referral'

export const referralRewardsQueryKey = ['referral', 'rewards'] as const
const REFERRAL_REWARDS_STALE_TIME_MS = 5 * 60 * 1000

export const referralRewardsQueryOptions = (enabled = true) => ({
  queryKey: referralRewardsQueryKey,
  queryFn: () => fetchReferralRewards(undefined),
  enabled,
  staleTime: REFERRAL_REWARDS_STALE_TIME_MS
})

export const useReferralRewards = (enabled = true) => useQuery(referralRewardsQueryOptions(enabled))
